document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const content = document.querySelector('[data-cart-drawer-content]');
  const orderRequestForm = document.querySelector('[data-order-request-form]');
  const deliveryMinimumCents = 3000;
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const fulfillmentPreference = (cart) => cart.attributes?.fulfillment_preference === 'delivery' ? 'delivery' : 'pickup';
  const fulfillmentOptions = (preference) => `<div class="fulfillment-selector" role="group" aria-label="Choose pickup or delivery"><p>Fulfillment preference</p><div class="fulfillment-selector__options"><button class="fulfillment-option${preference === 'pickup' ? ' is-selected' : ''}" type="button" data-fulfillment-option="pickup" aria-pressed="${preference === 'pickup'}"><strong>Pickup</strong><span>Pay in store</span></button><button class="fulfillment-option${preference === 'delivery' ? ' is-selected' : ''}" type="button" data-fulfillment-option="delivery" aria-pressed="${preference === 'delivery'}"><strong>Delivery</strong><span>Local service</span></button></div><small>Staff confirms availability, eligibility, and payment before fulfillment.</small></div>`;
  const deliveryMeter = (totalPrice) => {
    const remaining = Math.max(0, deliveryMinimumCents - totalPrice);
    const progress = Math.min(100, Math.round((totalPrice / deliveryMinimumCents) * 100));
    const status = remaining ? `${formatMoney(remaining)} to free delivery` : 'Free delivery unlocked';
    return `<section class="delivery-progress" aria-label="Delivery minimum progress"><div class="delivery-progress__heading"><span>Delivery meter</span><strong>${status}</strong></div><div class="delivery-progress__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}"><span style="width:${progress}%"></span></div><small>Free local delivery from $30 within the service area.</small></section>`;
  };
  const refreshCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    if (!content) return;
    if (!cart.item_count) {
      content.innerHTML = '<p class="cart-terminal__empty">Your stash is ready when you are.</p>';
      return;
    }
    const preference = fulfillmentPreference(cart);
    const items = cart.items.map((item) => `<div class="drawer-item"><span>${escapeHtml(item.product_title)} × ${item.quantity}</span><div class="drawer-item__actions"><strong>${formatMoney(item.final_line_price)}</strong><button class="drawer-item__remove" type="button" data-cart-remove="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(item.product_title)}">×</button></div></div>`).join('');
    content.innerHTML = `${fulfillmentOptions(preference)}${items}${deliveryMeter(cart.total_price)}<p class="drawer-total">Estimated total <strong>${formatMoney(cart.total_price)}</strong></p><p class="drawer-tax-included" role="note"><span class="drawer-tax-included__mark" aria-hidden="true">✓</span><span><strong>Taxes included</strong><small>Already accounted for in your final total.</small></span></p><a class="button button--primary" href="/cart">Review ${preference} request</a>`;
  };
  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', () => drawer?.classList.add('is-open')));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', () => drawer?.classList.remove('is-open')));
  content?.addEventListener('click', async (event) => {
    const fulfillmentButton = event.target.closest('[data-fulfillment-option]');
    if (fulfillmentButton) {
      const preference = fulfillmentButton.dataset.fulfillmentOption;
      fulfillmentButton.disabled = true;
      try {
        const response = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { fulfillment_preference: preference } }) });
        if (!response.ok) throw new Error('Unable to update fulfillment preference');
        refreshCart(await response.json());
      } catch {
        fulfillmentButton.disabled = false;
      }
      return;
    }
    const removeButton = event.target.closest('[data-cart-remove]');
    if (!removeButton) return;
    removeButton.disabled = true;
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: removeButton.dataset.cartRemove, quantity: 0 }) });
      if (!response.ok) throw new Error('Unable to remove item');
      refreshCart(await response.json());
    } catch {
      removeButton.disabled = false;
    }
  });
  orderRequestForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!orderRequestForm.checkValidity()) {
      orderRequestForm.reportValidity();
      return;
    }
    const submitButton = event.submitter || orderRequestForm.querySelector('[data-order-request-submit]');
    const updates = {};
    orderRequestForm.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      updates[input.dataset.cartQuantity] = Math.max(0, Number(input.value) || 0);
    });
    const acknowledgment = orderRequestForm.querySelector('[name="attributes[Customer acknowledgment]"]');
    const attributes = acknowledgment?.checked ? { 'Customer acknowledgment': acknowledgment.value } : {};
    if (submitButton) submitButton.disabled = true;
    try {
      const response = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, attributes }) });
      if (!response.ok) throw new Error('Unable to prepare order request');
      window.location.assign('/checkout');
    } catch {
      window.location.assign('/checkout');
    }
  });
  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) });
      if (!response.ok) throw new Error('Unable to add item');
      refreshCart(await (await fetch('/cart.js')).json());
      drawer?.classList.add('is-open');
    } catch {
      form.submit();
    } finally {
      button.disabled = false;
    }
  }));
});
